// extracted by mini-css-extract-plugin
export var container = "bz_b";
export var feature = "bz_b6";
export var featureText = "bz_b7";
export var features = "bz_b4";
export var footer = "bz_cb";
export var footerText = "bz_cc";
export var icon = "bz_bq";
export var section = "bz_d";
export var text = "bz_b0";
export var title = "bz_h";
export var waveOne = "bz_q";
export var waveThree = "bz_bZ";
export var waveTwo = "bz_n";
export var waves = "bz_bY";